// extracted by mini-css-extract-plugin
module.exports = {"default":"FJButtonBrick_default__1OZ9M"};